import { render, staticRenderFns } from "./PxSituacaoCompraIcon.vue?vue&type=template&id=16dc334f"
import script from "./PxSituacaoCompraIcon.vue?vue&type=script&lang=js"
export * from "./PxSituacaoCompraIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports